import { Record as record } from 'immutable';

import { construct, resolve } from '../../../helpers/LinkMapper';
import { getDefaults, getResolvers } from '../../../helpers/Records';
import trainTime from '../../../lib/TrainTime';
import { serialize, serializers } from '../../../helpers/SearchUrls';

const fieldSchema = {
    from: [ resolve.with(trainTime) ],
    to: [ resolve.with(trainTime) ]
};

class DatePeriod extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(DatePeriod, json, getResolvers(fieldSchema));
    }

    serialize () {
        return serialize({
            from: serializers.isoDateTime,
            to: serializers.isoDateTime
        }, this);
    }
}

export default DatePeriod;



// WEBPACK FOOTER //
// ./src/records/refund/itso/DatePeriod.js